import axios, { AxiosResponse } from 'axios';
import { ExportOptions, Title, TitleStatus, TitleTree } from '../domain/domain';
import { getHeaders, BASE_URL } from './common';

export function getTitleTreeByNumber(number: string) : Promise<AxiosResponse<TitleTree>> {
    return axios.get(BASE_URL + `/legal/title/tree?number=${number}`, {headers: getHeaders()});
}

export function search(query: string): Promise<AxiosResponse<TitleTree[]>> {
    return axios.get(BASE_URL + `/legal/title/search?query=${query}`, {headers: getHeaders()});
}

export function getTitles(): Promise<AxiosResponse<Title[]>> {
    return axios.get(BASE_URL + `/legal/titles`, {headers: getHeaders()});
}

export function updateTitle(id: number, title: Title): Promise<AxiosResponse<Title>> {
    return axios.put(BASE_URL + `/legal/titles/${id}`, title, {headers: getHeaders()});
}

export function createTitle(title: Title): Promise<AxiosResponse<Title>> {
    return axios.post(BASE_URL + `/legal/titles`, title, {headers: getHeaders()});
}

export function deleteTitleById(titleId: number): Promise<AxiosResponse<Title>> {
    return axios.delete(BASE_URL + `/legal/titles/${titleId}`, {headers: getHeaders()});
}

export function resetTitleStatuses(titleStatus: TitleStatus): Promise<AxiosResponse<Title[]>> {
    return axios.post(BASE_URL + `/legal/titles/reset?status=${titleStatus}`, "", {headers: getHeaders()});
}

export function exportNode(nodeId: number, exportOptions: ExportOptions): Promise<AxiosResponse<string>> {
    return axios({
        url: BASE_URL + `/legal/nodes/${nodeId}/export`,
        method: 'POST',
        data: exportOptions,
        responseType: 'blob',
        headers: getHeaders(),
    });
}

export function exportCrsToXML(): Promise<AxiosResponse<String>> {
    return axios.post(BASE_URL + `/legal/titles/print/all/xml`, "", {headers: getHeaders()});
}
